import MainLayout from "src/layouts/MainLayout";
import { usePageView } from "src/hooks/usePageView";
import ResourcesBanner from "./ResourcesBanner";
import ResourcesSection from "./ResourcesSection";
import DocumentPackage from "./DocumentPackage";
import {
  customerConditionsData,
  sellerConditionsData,
  fundingConditionsData,
  mspAllowanceData,
} from "./resourcesData";
import styled from "@emotion/styled";

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-top: 24px;
`;

export default () => {
  usePageView("Resources");

  return (
    <MainLayout page="resources" showHeading={true}>
      <ResourcesBanner />
      <Grid>
        <div>
          <ResourcesSection
            title="Customer Conditions"
            sectionData={customerConditionsData}
          />
        </div>
        <div>
          <ResourcesSection
            title="Seller Conditions"
            sectionData={sellerConditionsData}
          />
          <ResourcesSection
            title="Funding Conditions"
            sectionData={fundingConditionsData}
          />
          <ResourcesSection
            title="MSP Allowance Chart"
            sectionData={mspAllowanceData}
          />
        </div>
        <div>
          <DocumentPackage />
        </div>
      </Grid>
    </MainLayout>
  );
};
